import React, {Component, Fragment} from 'react'
import StyleSheet from '../../styles'
import Typography from '@material-ui/core/Typography'
import { deepGet, isEmpty } from '../../utils/CollectionUtils'
import { validateRequired } from '../../utils/Validators'
import {FormattedMessage} from 'react-intl'

export class Stages extends Component {
  constructor(props) {
    super(props)
    this.validateRef = {validate: callback => this.validate(callback), validateStage: this.validateStage}
    this.props.validateRef && this.props.validateRef(this.validateRef)
  }

  state = {
    completeStages: {},
    startedStages: {},
    errors: {}
  }

  static defaultProps = {
    errors: {},
    validators: [validateRequired]
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.stage !== this.props.stage && !this.props.manualValidation) {
      if (!this.getStage(prevProps.stage).review)
        this.validate()
      window.scrollTo(0,0)
    }
    if (prevProps.stage === this.props.stage && this._prevStageName && this.getStage(this.props.stage).name !== this._prevStageName) {
      const stageIndex = this.stages.findIndex(s => s.name === this._prevStageName)
      if (stageIndex > -1 && stageIndex !== this.props.stage)
        this.props.onStageChange(stageIndex, this.stages)
    }
    this._prevStageName = this.getStage(this.props.stage).name

    if (this.props.stage >= this.stages.length)
      this.props.onStageChange(this.stages.length - 1, this.stages)
  }

  get stages() {
    if (!this._stages || this.props.children !== this._lastChildren) {
      this._stages = [
        ...React.Children.map(this.props.children, child => child && !child.props.hidden && ({
          name: child.props.name,
          title: child.props.title || `${child.props.name}.title`,
          optional: child.props.optional || child.props.review,
          review: child.props.review,
          hidden: child.props.hidden,
          hideRequiredFieldHelper: child.props.hideRequiredFieldHelper,
          component: child
        }))
      ].filter(s => s)
      this._lastChildren = this.props.children
    }
    return this._stages
  }

  getStage = stageId => {
    return (stageId >= 0 && this.stages[stageId]) || {}
  }

  get showStages() {
    return this.stages.length > 1
  }

  handleStageChange = (newStage) => {
    this.props.onStageChange(newStage, this.stages)
  }

  componentDidMount = () => {
    const stages = this.stages
    this.handleStageChange(stages.findIndex((stage, i) => i === stages.length - 1 || !this.complete(this.meta[stage.name])), stages)
    this.props.validateRef && this.props.validateRef(this.validateRef)
  }

  validate = (callback) => {
    const validationStatus = {
      errors: this.props.validators.reduce((result, validator) => ({...result, ...validator(this.mergedMeta, this.props.context)}), {}),
      completeStages: this.stages.reduce((result, stage) => ({...result, [stage.name]: this.complete(this.meta[stage.name])}), {}),
      startedStages: this.stages.reduce((result, stage) => ({...result, [stage.name]: this.started(this.meta[stage.name])}), {})
    }
    this.validateRef.validationStatus = validationStatus
    this.setState(validationStatus, () => callback && callback(validationStatus))
    return Object.keys(validationStatus.errors).length > 0
  }

  validateStage = (stageId) => {
    const meta = Object.values(this.meta)[stageId]
    if (!this.props.complete && !this.started(meta)) {
      return true
    }
    console.log(Object.values(this.meta))
    console.log(stageId)
    console.log(this.props.validators.reduce((result, validator) => ({...result, ...validator(this.mergedMeta, this.props.context)}), {}))
    return this.props.validators.every((validator) => Object.keys(validator(meta, this.props.context)).length === 0)
  }

  started = meta => {
    return meta && Object.keys(meta).some(k => {
      if(meta[k].prepopulated) {
        return false
      }

      let value = deepGet(k, this.props.context)
      if(Array.isArray(value)) {
        return value.length !== 0
      }

      return !!value
    })
  }

  complete = meta =>
    meta && this.started(meta) && isEmpty(validateRequired(meta, this.props.context))

  handleMetaRef = (stageName, meta) => {
    this.meta = {...this.meta, [stageName]: meta}
    this.mergedMeta = Object.keys(this.meta).reduce((result, key) => ({...result, ...this.meta[key]}), {})
  }

  stageErrors = name => {
    const errors = {}
    if (this.meta && this.meta[name]) {
      if (this.props.errors)
        Object.keys(this.meta[name]).forEach(k => {
          const errorMember = this.meta[name][k].errorMember
          if (this.props.errors[errorMember])
            errors[errorMember] = this.props.errors[errorMember]
        })
      if (this.props.complete || this.state.startedStages[name]) {
        Object.keys(this.meta[name]).forEach(k => {
          const errorMember = this.meta[name][k].errorMember
          if (this.state.errors[errorMember])
            errors[errorMember] = this.state.errors[errorMember]
        })
      }
    }

    return errors
  }

  stageHasErrors = name =>
    Object.keys(this.stageErrors(name) || {}).length > 0

  renderErrorSummary = () =>
    this.stages.some(({name}) => this.stageHasErrors(name)) &&
    <div className={styles.errors}>
      <p className={styles.errorHelper}>To continue, please correct the following:</p>
      {this.stages.map(stage => {
        const errors = this.stageErrors(stage.name)
        if (!stage.review && this.stageHasErrors(stage.name)) {
          const stageMeta = this.meta[stage.name]
          return !stage.review && this.stageHasErrors(stage.name) && (
            <div>
              <h3><FormattedMessage id={stage.name} /></h3>
              <dl>
                {Object.keys(errors).map(key => {
                  const metaItem = stageMeta[Object.keys(stageMeta).find(k => stageMeta[k].errorMember === key)]
                  return (
                    <Fragment>
                      <dt>{metaItem.errorLabel || metaItem.label}</dt>
                      <dd>{errors[key]}</dd>
                    </Fragment>
                  )
                })}
              </dl>
            </div>
          )
        }
        return undefined
      })}
    </div>


  renderProgress = () => {
    const stages = this.stages
    const {completeStages} = this.state
    const {stage: stageId} = this.props
    return this.showStages && (
      <ul className={styles.stageProgress}>
        {stages.map((stage, i) =>
          <li
            key={stage.name}
            className={styles({
              enabled: true,
              active: i === stageId,
              error: this.stageHasErrors(stage.name),
              complete: !this.stageHasErrors(stage.name) && !!completeStages[stage.name]
            })}
            onClick={() => this.handleStageChange(i)}
          >
            <span className={styles.status}>{i + 1}</span><FormattedMessage id={stage.name} />
          </li>
        )}
      </ul>
    )
  }

  renderStages = () => {
    const stages = this.stages
    const {context, onChange, stage: stageId} = this.props

    return stages.map((stage, i) =>
      <div className={styles({stage: true, hidden: i !== stageId})} key={stage.name}>

        <Typography variant="h5">
          <FormattedMessage id={stage.title} />
          {' '}
          {!stage.review && !stage.hideRequiredFieldHelper && (
            <Typography variant="body1"><FormattedMessage id="help.required_fields" /></Typography>
          )}
        </Typography>
        {(!stage.review || i === stageId) && React.cloneElement(stages[i].component, {
          context, onChange, stages,
          metaRef: !stage.review && (meta => this.handleMetaRef(stage.name, meta)),
          errorContext: this.stageErrors(stage.name),
          onStageChange: this.handleStageChange,
        })}
      </div>
    )
  }

  render = () =>
    <Fragment>
      {this.renderErrorSummary()}
      {this.renderProgress()}
      {this.renderStages()}
    </Fragment>
}

const styles = StyleSheet({
  stageProgress: {
    minHeight: 50,
    width: '100%',
    borderRadius: 25,
    backgroundColor: 'rgba(245,245,245,0.95)',
    boxSizing: 'border-box',
    margin: [20, 0],
    padding: 0,
    display: 'flex',
    flexWrap: 'wrap',

    '@media print': {
      display: 'none'
    },

    '& li': {
      listStyle: 'none',
      borderRadius: 19,
      padding: 4,
      margin: 6,
      verticalAlign: 'middle',
      fontWeight: 'bold',
      fontSize: '10px',
      color: '#9b9b9b',
      transition: 'color 500ms, background-color 500ms',
      flexGrow: 1,
      '&$enabled': {
        cursor: 'pointer',
      },
      '& $status': {
        transition: 'background-color 500ms',
      },
      '&$active': {
        backgroundColor: 'rgba(0,0,0,0.07) !important',
        color: '#586c7b',
        '& $status': {
          backgroundColor: '#586c7b',
        }
      },
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.03)',
      },
      '&$error': {
        color: '#e94537 !important',
        '& $status': {
          backgroundColor: '#e94537 !important'
        }
      },
      '&$complete': {
        color: '#90c814 !important',
        '& $status': {
          backgroundColor: '#90c814 !important'
        }
      }

    },

  },
  status: {
    display: 'inline-block',
    verticalAlign: 'middle',
    height: 30,
    width: 30,
    borderRadius: 15,
    backgroundColor: '#9b9b9b',
    marginRight: 10,
    color: 'white',
    textAlign: 'center',
    fontSize: '12px',
    boxSizing: 'border-box',
    paddingTop: 7,
  },
  active: {},
  enabled: {},
  stage: {
    opacity: 1,
    transition: 'opacity 500ms',
    maxWidth: 556,
    width: '100%',
    marginBottom: 50,
    position: 'relative'
  },
  error: {},
  complete: {},
  hidden: {
    visibility: 'hidden',
    height: 0,
    overflow: 'hidden',
    opacity: 0.3,
    marginBottom: 0,
  },
  errors: {
    marginTop: 20,
    backgroundColor: '#e94537',
    color: '#FFF',
    padding: [25, 15],
    borderRadius: 25,
    '& h2': {
      marginTop: 0,
    },
    '& h6': {
      marginTop: 0,
      marginBottom: 5,
      paddingTop: '0 !important'
    },
    '& dl': {
      padding: [8, 10],
      margin: [0, 15, 10],
      borderLeft: '1px solid #FFF',
      '&:after': {
        content: `''`,
        clear: 'both',
        display: 'block',
      }
    },
    '& dt': {
      padding: [2, 0],
      fontWeight: 500,
      float: 'left',
      clear: 'left',
      '&:after': {
        content: `' - '`,
        whiteSpace: 'pre'
      }
    },
    '& dd': {
      padding: [2, 0],
      float: 'left',
      clear: 'right',
      marginLeft: 2,
    }
  },
  errorHelper: {
    marginTop: 0,
    fontWeight: 'bolder',
  }
})